import axios  from "components/AxiosUtils";
import { getFileNameFromContentDisposition } from "components/Utils";

interface DownloadRequest {
    templateDocuments: number[];
    uploadedDocuments: number[];
    format: number; // 0 = PDF, 1 = ZIP
    includeStudentName: boolean;
}

export async function downloadSectionsPDFRep(applicationFormUid: string, isAnonymous: boolean): Promise<{blob: Blob, filename: string}> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/ApplicationFormSection/GetPdfs/${applicationFormUid}?isAnonymous=${isAnonymous}`,
            { headers: {  "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );
        const filename = getFileNameFromContentDisposition(response.headers["content-disposition"]);
        const blob = new Blob([new Uint8Array(response.data)]);

        return {blob: blob, filename: filename ?? "AllSections.zip"};
    }
    catch (err: any) {
        throw err;
    }
}

export async function downloadAgreementsPDFRep(applicationFormUid: string): Promise<{blob: Blob, filename: string}> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/Agreement/GetAllAgreements/${applicationFormUid}`,
            { headers: {  "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const filename = getFileNameFromContentDisposition(response.headers["content-disposition"]);

        const blob = new Blob([new Uint8Array(response.data)]);

        return {blob: blob, filename: filename ?? "Agreements.zip"};
    }
    catch (err: any) {
        throw err;
    }
}

export async function downloadAllFilesRep(applicationFormUid: string): Promise<Blob> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/TBA/${applicationFormUid}`,
            { headers: { "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const blob = new Blob([new Uint8Array(response.data)]);

        return blob;
    }
    catch (err: any) {
        throw err;
    }
}

export async function generateTemporaryLinkWithAllFilesRep(applicationFormUid: string): Promise<Blob> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/TBA/${applicationFormUid}`,
            { headers: {  "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const blob = new Blob([new Uint8Array(response.data)]);

        return blob;
    }
    catch (err: any) {
        throw err;
    }
}

export async function downloadSeparateTemplatesRep(applicationFormUid: string): Promise<Blob> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/TBA/${applicationFormUid}`,
            { headers: { "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const blob = new Blob([new Uint8Array(response.data)]);

        return blob;
    }
    catch (err: any) {
        throw err;
    }
}

export async function synchronizeApplicationFormStatusRep(formData: { appFormUid: string, applicationFormStatus: number }): Promise<void> {
    try {
        await axios.post(
            `/ApplicationForm/synchronizeApplicationFormStatus`,
            formData,
        );
    }
    catch (err: any) {
        throw err;
    }
}

export async function exportDataToOMGTRep(applicationFormUid: string): Promise<void> {
    try {
        await axios.post(
            `/ApplicationForm/ExportDataToWEP/${applicationFormUid}`,
            {},
        );
    }
    catch (err: any) {
        throw err;
    }
}


export async function DownloadVirtualFolderRep(applicationFormUid: string): Promise<{blob: Blob, filename: string}> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/DocumentFolder/DownloadVirtualFolder/${applicationFormUid}`,
            { headers: {  "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const filename = getFileNameFromContentDisposition(response.headers["content-disposition"]);

        const blob = new Blob([new Uint8Array(response.data)]);

        return {blob: blob, filename: filename ?? "VirtualFolder.zip"};
    }
    catch (err: any) {
        throw err;
    }
}
export async function DownloadBioInfoRep(applicationFormUid: string): Promise<{blob: Blob, filename: string}> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/Applicant/DownloadBioInfo/${applicationFormUid}`,
            { headers: {  "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const filename = getFileNameFromContentDisposition(response.headers["content-disposition"]);

        const blob = new Blob([new Uint8Array(response.data)]);

        return {blob: blob, filename: filename ?? "BioInfo.zip"};
    }
    catch (err: any) {
        throw err;
    }
}
export async function DownloadAllRep(applicationFormUid: string, isAnonymous : Boolean): Promise<{blob: Blob, filename: string}> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/Applicant/DownloadAll/${applicationFormUid}?isAnonymous=${isAnonymous}`,
            { headers: {  "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const filename = getFileNameFromContentDisposition(response.headers["content-disposition"]);

        const blob = new Blob([new Uint8Array(response.data)]);

        return {blob: blob, filename: filename ?? "AllDocuments.zip"};
    }
    catch (err: any) {
        throw err;
    }
}

export async function DownloadDocuments(applicationFormUid: string, payload : DownloadRequest): Promise<{blob: Blob, filename: string}> {
    try {
        const format = typeof payload.format === 'string' ? (payload.format === 'zip' ? 1 : 0) : payload.format;

        const response = await axios.post<ArrayBuffer>(
        `/Applicant/DownloadDocuments/${applicationFormUid}`, payload,
            {
                responseType: 'arraybuffer'
            }
        );
        const filename = getFileNameFromContentDisposition(response.headers["content-disposition"]);

        const blob = new Blob([new Uint8Array(response.data)]);

        return {blob: blob, 
            filename: filename ?? (format === 1 // 1 = ZIP
            ? "documents.zip"
            : "documents.pdf")
        };
    }
    catch (err: any) {
        throw err;
    }
}


export async function DownloadPhotoAlbumRep(applicationFormUid: string): Promise<{blob: Blob, filename: string}> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/MediaAlbum/DownloadPhotoAlbum/${applicationFormUid}`,
            { headers: { "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const filename = getFileNameFromContentDisposition(response.headers["content-disposition"]);

        const blob = new Blob([new Uint8Array(response.data)]);

        return {blob: blob, filename: filename ?? "PhotoAlbum.zip"};
    }
    catch (err: any) {
        throw err;
    }
}

export async function notifyAppFormUserOfAccountRep(
  applicationFormUid: string,
  userEmail: string | null = null
): Promise<void> {
  try {
    const params = new URLSearchParams({ uid: applicationFormUid });
    if (userEmail !== null) {
      params.append('email', userEmail);
    }

    await axios.post(`/ApplicationForm/NotifyAppFormUserOfAccount?${params.toString()}`);
  } catch (err) {
    throw err;
  }
}

  

export async function downloadSectionsConcatPDFRep(applicationFormUid: string, isAnonymous: boolean): Promise<{blob: Blob, filename: string}> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/ApplicationFormSection/GetConcatPdfs/${applicationFormUid}?isAnonymous=${isAnonymous}`,
            { headers: {  "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const filename = getFileNameFromContentDisposition(response.headers["content-disposition"]);

        const blob = new Blob([new Uint8Array(response.data)]);

        return {blob: blob, filename: filename ?? "allSections.pdf"};
    }
    catch (err: any) {
        throw err;
    }
}

export async function downloadAgreementsConcatPDFRep(applicationFormUid: string): Promise<{blob: Blob, filename: string}> {
    try {
        const response = await axios.get<ArrayBuffer>(
            `/Agreement/GetConcatAgreementPdfs/${applicationFormUid}`,
            { headers: {  "Content-Type": "application/octet-stream" }, responseType: 'arraybuffer' }
        );

        const filename = getFileNameFromContentDisposition(response.headers["content-disposition"]);

        const blob = new Blob([new Uint8Array(response.data)]);

        return {blob: blob, filename: filename ?? "Agreements.pdf"};
    }
    catch (err: any) {
        throw err;
    }
}
